import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import type { Profile } from "../mock/types";
import { getInitials, profileColorClass } from "../mock/helpers";

export function AvatarStack({
	profiles,
	max = 3,
	size = "sm",
	className,
}: {
	profiles: Profile[];
	max?: number;
	size?: "sm" | "md";
	className?: string;
}) {
	if (profiles.length === 0) return null;
	const visible = profiles.slice(0, max);
	const overflow = profiles.length - visible.length;
	const dims = size === "sm" ? "h-5 w-5" : "h-8 w-8";
	const textSize = size === "sm" ? "text-[9px]" : "text-[10px]";

	return (
		<div className={cn("flex items-center -space-x-1.5", className)}>
			{visible.map((p) => (
				<Avatar key={p.id} className={cn(dims, "ring-2 ring-surface")}>
					{p.avatar_url && (
						<AvatarImage
							src={p.avatar_url}
							alt={p.full_name ?? p.email}
						/>
					)}
					<AvatarFallback
						className={`${textSize} text-white ${profileColorClass(p.id)}`}
					>
						{getInitials(p.full_name ?? p.email)}
					</AvatarFallback>
				</Avatar>
			))}
			{overflow > 0 && (
				<div
					className={cn(
						dims,
						textSize,
						"flex items-center justify-center rounded-full bg-muted-subtle text-muted font-medium ring-2 ring-surface",
					)}
				>
					+{overflow}
				</div>
			)}
		</div>
	);
}
